export default __webpack_public_path__ + "static/ayvakit-logo-og-tablets-87fc92d361c5ca144c2ebb1ac3927ea4.png";